import type { ReactNode } from 'react';
import type { IColumn, ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import type { IColumnCustomizationEntry } from '@/creditflowresearch/application/BondScreener/Sidebar/useColumnsCustomization';
import type { TColumnScope } from '@/creditflowresearch/domain/vo/Bondscreener';

import columnsStyles from '../columnsTabContent.module.scss';

const SCOPE_LABELS: Record<TColumnScope, string> = {
  tranche: 'Tranche',
  deal: 'Deal',
};

const SCOPE_ORDER: TColumnScope[] = ['tranche', 'deal'];

const formatScope = (scope: TColumnScope[]): string =>
  SCOPE_ORDER
    .filter((scopeId) => scope.includes(scopeId))
    .map((scopeId) => SCOPE_LABELS[scopeId])
    .join(', ');

export const scopeColumn: IColumn = {
  name: 'scope',
  title: 'Tab',
  width: 120,
  minWidth: 120,
  maxWidth: 120,
  isDraggable: false,
  cellCallback: ({ row }: ICellProps<IColumnCustomizationEntry>): ReactNode => (
    <span className={ columnsStyles.scopeValue }>{ formatScope(row.scope) }</span>
  ),
};
